// import menu from './menu'
import swiper from './swiper'
import objectFitImages from 'object-fit-images'
// import trancator from './trancator'
import hasHash from './hasHash'


// menu()
swiper()
objectFitImages()
// trancator()
hasHash()
